// extracted by mini-css-extract-plugin
export var root = "_50531a858c90d1060d99b6fcc5b10cbd-css";